import { enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { CommonModule } from '@angular/common';
import { withHashLocation, provideRouter, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { SecurityService } from '@services/SecurityService';
import { DataServ } from '@services/GlobalService';
import OktaAuth from '@okta/okta-auth-js';
import { OktaAuthModule } from '@okta/okta-angular';


const oktaAuth = new OktaAuth({
    clientId: environment.OktaClientID,
    issuer: environment.OktaIssuer,
    redirectUri: environment.OktaLoginCallback,
    scopes: ['default', 'openid', 'profile', 'email', 'offline_access'],
    pkce: true
  })

const routes: Routes = [
  { path: '', loadChildren: () => import('@modules/ifms.module').then(m => m.IfmsModule) },
    //{ path: '**', redirectTo: ''}
  ];


export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
          BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }), FormsModule, CommonModule, OktaAuthModule.forRoot({ oktaAuth })
        ),
        DataServ, SecurityService,
        //,{
        //provide: HTTP_INTERCEPTORS,
        //useClass: AuthInterceptorService,
        //multi: true
        //}
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        //provideRouter(routes, withHashLocation())
        provideRouter(routes)
    ]
})
  .catch(err => console.log(err));
